module.exports = __webpack_public_path__ + "static/media/UI.51eba4ba.webp";